
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'MobileFooter',
  props: {
    fixed: { type: Boolean, default: false },
    sticky: { type: Boolean, default: false }
  },
  setup(props) {
    const fixedStyle = computed(() => typeof props.fixed === 'string' || !!props.fixed)
    const stickyStyle = computed(() => typeof props.sticky === 'string' || !!props.sticky)
    return {
      fixedStyle,
      stickyStyle
    }
  }
})
